import {
  FC, useEffect, useMemo, 
} from 'react';
import { useTranslation } from 'react-i18next';

import withPrintPDF, { IWithPrintPDFComponentProps } from 'HOC/withPrintPDF';
import CroptimizerBoard from 'features/Croptimizer/screen/1Board/Board';
import CropRotation from 'features/Croptimizer/screen/3CropRotation/CropRotation';
import SupplyPlan from 'features/Croptimizer/screen/4SupplyPlan';
import Synthesis from 'features/Croptimizer/screen/5Synthesis';
import { cn } from 'utils/cn';
import FiveYearsBoard from 'features/Croptimizer/screen/2Strategy/FiveYearsBoard';

import { generateFilename, tabArr } from '../utils/constants';
import { PDFCroptimizerContent } from '../components/PDFCroptimizerContent/PDFCroptimizerContent';
import { TabBar, Warning } from '../components/TabBar';
import { useCroptimizer } from '../providers/CroptimizerContext';

// TODO: need to describe props type
export interface Props {
  [key: string]: any;
}

const CroptimizerContent: FC<Props & IWithPrintPDFComponentProps> = (props) => {
  const { isPDF, handlePrint, printLoading, setDocumentTitle } = props;
  const { t } = useTranslation();

  const { activeTab, step } = useCroptimizer();

  const getGeneratedFileName = useMemo(
    () => generateFilename(activeTab, step),
    [activeTab, step],
  );

  useEffect(() => {
    if (!isPDF) {
      setDocumentTitle(getGeneratedFileName);
    }
  }, [getGeneratedFileName]);

  const renderContent = () => {
    switch (activeTab) {
      case 1:
        return <CroptimizerBoard isPDF={isPDF} />;
      case 2:
        return <FiveYearsBoard isPDF={isPDF} />;
      case 3:
        return <CropRotation isPDF={isPDF} />;
      case 4:
        return <SupplyPlan isPDF={isPDF} />;
      case 5:
        return <Synthesis isPDF={isPDF} />;
    }
  };

  if (isPDF) {
    return <PDFCroptimizerContent {...props} />;
  }

  return (
    <div id="croptimizer" className="max-w-[1700px] mx-auto">
      <div
        className={cn(
          { 'px-[100px] py-[32px] md:px-[16px] md:pb-4': !isPDF },
          { 'px-[16px] pb-4': isPDF },
        )}
      >
        {isPDF ? (
          <div className="flex justify-center mb-4">
            <div className={'font-bold text-center text-lg'}>
              {t(tabArr.find((tab) => tab.id === activeTab)?.title || '')}
            </div>
          </div>
        ) : (
          <TabBar handlePrint={handlePrint} printLoading={printLoading} />
        )}
        <div className="mt-24 sm:mt-[250px]">{renderContent()}</div>
      </div>

      {isPDF && <Warning />}
    </div>
  );
};

export default withPrintPDF(CroptimizerContent);
